<template>
<div :key="borderKey" ref="borderBox" class="panel-root">
  <div id="centerLeft1">
    <div class="bg-color-black">
      <div class="d-flex h10">
        <!-- <span>
          <icon name="chart-bar" class="text-icon"></icon>
        </span> -->
        <div class="d-flex assetsPieTitle">
          <span class="fs-xl text_title mx-2 commonTitle">织物流通品类占比</span>
          <dv-decoration-3 class="dv-dec-3" />
        </div>
      </div>
      <div class="d-flex jc-center h100">
        <CenterLeft1Chart :data="result" />
      </div>
      <!-- 4涓富瑕佺殑鏁版嵁 -->
      <!-- <div class="bottom-data">
        <div class="item-box mt-2" v-for="(item, index) in numberData" :key="index">
          <div class="d-flex">
            <span class="coin">锟?/span>
            <dv-digital-flop class="dv-digital-flop" :config="item.number" />
          </div>
          <p class="text" style="text-align: center;">
            {{ item.text }}
            <span class="colorYellow">(浠?</span>
          </p>
        </div>
      </div> -->
    </div>
  </div>
</div>
</template>

<script>
import CenterLeft1Chart from '@/components/echart/centerLeft/centerLeft1ChartIndex2'
import * as api from '@/api/index'
export default {
  data() {
    return {
      borderKey:'1',
      numberData: [
        {
          number: {
            number: [15],
            toFixed: 1,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          text: 'pending'
        },
        {
          number: {
            number: [1144],
            toFixed: 1,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          text: 'processed'
        },
        {
          number: {
            number: [361],
            toFixed: 1,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          text: 'my flow'
        },
        {
          number: {
            number: [157],
            toFixed: 1,
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          text: 'to sign'
        }
      ],
      params: {
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        customerId: '',
        checkStatusFlag : true
      },
      result: [],
      intervalId: null // 鐢ㄤ簬瀛樺偍瀹氭椂鍣ㄧ殑 ID
    }
  },
  components: {
    CenterLeft1Chart
  },
  mounted() {
    // this.changeTiming()
    this.params.customerId = this.$route.query.customerId
    // first load
    this.getData()
    this.pieOutlineFunc()

    this.intervalId = setInterval(() => {
      this.getData()
      this.pieOutlineFunc()
    }, 30 * 60 * 1000)

  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    pieOutlineFunc () {
      var _this=this
      window.addEventListener('resize', function(e){
        _this.$nextTick(()=>{
          // console.log('kkkkkkkkkkkkkkkkkkk')
          _this.borderKey++

          setTimeout(() => { 
            if (_this.$refs.borderBox && _this.$refs.borderBox.initWH) {
              _this.$refs.borderBox.initWH()
            }
          }, 300)

        })

      })
    },

    //缁囩墿鍒嗙被缁熻
    async getData() {
      const res = await api.getBigSkuCategory(this.params)
      // console.log(res, '-----------666666')
      this.result = res.Result
    },
    changeTiming() {
      setInterval(() => {
        this.changeNumber()
      }, 3000)
    },
    changeNumber() {
      this.numberData.forEach((item, index) => {
        item.number.number[0] += ++index
        item.number = { ...item.number }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// $box-width: 500px;
// $box-height: 350px;

#centerLeft1 {
  //padding: 16px 0px;
  // height: $box-height;
  //width: 100%;
  border-radius: 10px;
  height: 100%;
  .bg-color-black {
    // height: $box-height - 30px;
    border-radius: 10px;
    height: 100%;
  }
  .h10{
    height: 10%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 0 15px;
    position: relative;
    top: 1rem;
  }
  .h90{
    height: 85%;
  }
  .h100{
    height: 85%;
  }
  .dv-dec-3 {
    position: relative;
    width: 100px;
    height: 20px;
    top: -3px;
  }

  .bottom-data {
    .item-box {
      &>div {
        padding-right: 5px;
      }

      font-size: 14px;
      float: right;
      position: relative;
      width: 50%;
      color: #d3d6dd;

      .dv-digital-flop {
        width: 120px;
        height: 30px;
      }

      // 閲戝竵
      .coin {
        position: relative;
        top: 6px;
        font-size: 20px;
        color: #ffc107;
      }

      .colorYellow {
        color: yellowgreen;
      }

      p {
        text-align: center;
      }
    }
  }
}

.panel-root {
  width: 100%;
  height: 100%;
}
</style>

